import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';

export const createCargoChangeData = (cargo: RotationCargo) => {
    return {
        imosCargoId: cargo.imosCargoId,
        productId: cargo.productId,
        chartererName: cargo.chartererName,
        cargoNumber: cargo.cargoNumber,
        voyageNumber: cargo.voyageNumber,
        temperature: cargo.temperature,
        optionType: cargo.optionType,
        optionMinusPercentage: cargo.optionMinusPercentage,
        optionPlusPercentage: cargo.optionPlusPercentage,
        productChanges: cargo.productChanges,
        dataSource: cargo.dataSource,
        cargoStatus: cargo.cargoStatus,
        comment: cargo.comment,
    };
};
